module.exports = __webpack_public_path__ + "MaterialIcons-Regular.b40b58088cbe69d8d205bffbb23c29fb.hashedasset.svg";